<div *ngIf="user" class="w-100 d-flex justify-content-end align-items-center">
  <div
    *ngIf="canCreateLog"
    ngbTooltip="Create Quick Walk Session"
    #quickWalkTooltip="ngbTooltip"
    placement="top"
    [style.display]="'inline-block'"
    [style.margin-right]="'1rem'">
    <button
      aria-label="quick-walk-session-icon"
      placement="bottom-end"
      class="btn-reset quick-walk-icon"
      (click)="openQuickWalkModal(); quickWalkTooltip.close()">
      <i class="bi bi-clipboard2-check-fill"></i>
    </button>
  </div>
  <div
    ngbTooltip="Throw Confetti"
    #confettiTooltip="ngbTooltip"
    placement="top"
    [style.display]="'inline-block'"
    [style.margin-right]="'1rem'">
    <button
      aria-label="dashboard-celebration-icon"
      placement="bottom-end"
      class="icon btn-reset confetti-icon"
      (click)="cueConfetti(); confettiTooltip.close()">
      <img
        src="/assets/confetti-sm.svg"
        class="confetti"
        alt="Throw confetti" />
    </button>
  </div>
  <div
    ngbDropdown
    #celebrationsDropdown="ngbDropdown"
    [autoClose]="'outside'"
    placement="bottom-end"
    ngbTooltip="Celebrations"
    #celebrationsTooltip="ngbTooltip"
    [style.display]="'inline-block'"
    [style.margin-right]="'1rem'">
    <button
      ngbDropdownToggle
      aria-label="celebrations-header-icon"
      class="btn-reset celebrations-icon"
      (click)="celebrationsTooltip.close()">
      <img
        src="/assets/celebrate-star.svg"
        class="cstar"
        alt="celebration star" />
    </button>
    <div
      ngbDropdownMenu
      class="dropdown-menu dropdown-menu-end celebrations-panel">
      <div class="celebrations-scroll">
        <app-card-celebrations-feed
          (createCelebrationEvent)="handleCreateCelebrationEvent()"
          [celebrations]="celebrations"
          [user]="user" />
      </div>
      <div
        class="celebrations-footer d-flex justify-content-between align-items-center">
        <button
          (click)="openCelebrationModal()"
          class="btn btn-warning btn-sm celebrations-create-btn fw-700">
          <i class="bi bi-plus-lg"></i>
          Create a Celebration
        </button>
        <a
          href="javascript:void(0)"
          (click)="goToCelebrationsPage()"
          class="celebrations-see-all fs-14">
          See all Celebrations
        </a>
      </div>
    </div>
  </div>

  <app-notifications-bell />
  <app-create-edit-celebration-modal
    (createCelebrationEvent)="handleCreateCelebrationEvent()"
    [user]="user"
    #celebrationModal />
  <app-create-quick-walk-modal #createQuickWalkModal />
</div>
